import { useEffect } from 'react';
import { useActions } from 'lib/hooks';
import { getErrorModalOptions } from './getErrorModalOptions';
import { LatestRef } from './types';
import * as codes from './errorCodes';

const updatePaymentErrorCodes = [
  codes.PAYMENT_FAILED_CREDIT_CARD_DECLINED,
  codes.PAYMENT_FAILED_CREDIT_CARD_EXPIRED,
  codes.PAYMENT_FAILED_CREDIT_CARD_INSUFFICIENT_BALANCE,
  codes.PAYMENT_FAILED_POINTS_INSUFFICIENT_BALANCE,
  codes.REFUND_FAILED_CREDIT_CARD_EXPIRED,
];

export function useAmendmentErrorFlow(ref: LatestRef) {
  const actions = useActions();

  const { errorCode } = ref.current;

  useEffect(() => {
    // If not in error state, do nothing
    if (!errorCode) return;

    // navigate to update payment method
    if (updatePaymentErrorCodes.includes(errorCode)) {
      ref.current.navigateTo.updatePaymentMethod('replace', ref.current.booking.id);
    }

    if (errorCode !== codes.INVENTORY_UNAVAILABLE) {
      actions.modal.setupModal({ isOpen: true, ...getErrorModalOptions(errorCode) });
    }

    // display modal
  }, [ref, actions.modal, errorCode]);
}
